<template>
  <v-app id="app" >
    <img height="1" width="1" style="display:none"
      :src="pix_api_url"
    />
    <router-view/>
  </v-app>
</template>

<script>

  export default {
    name: 'app',

    data: () => ({
      pix_api_url: '',
    }),

    mounted() {
      this.pix_api_url = "https://www.facebook.com/tr?id=%key&ev=PageView&noscript=1".replace('%key', process.env.VUE_APP_FACEBOOK_PIXEL_KEY);
    }
  
  };

  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', process.env.VUE_APP_FACEBOOK_PIXEL_KEY);
  fbq('track', 'PageView');
  
</script>

<style>
#app {
 margin-top: 0px
}
</style>
